import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQS } from "../lib/content";

export default function FAQ() {
  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20" data-testid="faq-page">
      <div className="text-xs uppercase tracking-widest text-[#1D4ED8]">FAQs</div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-[1.1]">Answers, without the sales-talk.</h1>

      <Accordion type="single" collapsible className="mt-12 bg-white border border-zinc-200 rounded-3xl px-2">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="px-6">
            <AccordionTrigger className="text-left text-lg font-medium hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-zinc-700 leading-relaxed pb-6">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <div className="mt-16 bg-[#EFF6FF] border border-[#1D4ED8]/20 rounded-3xl p-10">
        <div className="font-display text-3xl leading-snug max-w-2xl">Still have a question?</div>
        <p className="text-zinc-700 mt-3 max-w-xl">The Clarity Call exists precisely for this — to give you structured answers to your specific situation.</p>
        <Link to="/clarity-call" className="btn-primary mt-6">Book a Clarity Call</Link>
      </div>
    </div>
  );
}
